import React, { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { DialogProvider, ScrollToTop } from '../Components/Shared'
import Loader from '../Components/Shared/Loader'
import MUIDrawer from '../Components/Shared/MUI-Drawer'
import { DrawerData as initialDrawerData } from '../Constants/Constant/SidebarConstent'
import { UnsavedChangesProvider } from '../Context/UnsavedChangesProvider'

const DefaultLayout: React.FC = () => {
  const [drawerData] = useState(initialDrawerData)

  return (
    <UnsavedChangesProvider>
      <MUIDrawer drawerData={drawerData}>
        <Suspense fallback={<Loader />}>
          <DialogProvider>
            <div className='root'>
              <Loader />
              <Outlet />
              <ScrollToTop />
            </div>
          </DialogProvider>
        </Suspense>
      </MUIDrawer>
    </UnsavedChangesProvider>
  )
}

export default DefaultLayout
